export const ethnicGroups = [
  {
    title: "Prefer not to say",
    value: "Prefer not to say",
    id: "6fa4fc88-55fd-11ee-8c99-0242ac120002",
  },
  {
    title: "Asian, Asian British or Asian Welsh",
    value: "Asian, Asian British or Asian Welsh",
    id: "c3a28120-55fd-11ee-8c99-0242ac120002",
  },
  {
    title: "Black, Black British, Black Welsh, Caribbean or African",
    value: "Black, Black British, Black Welsh, Caribbean or African",
    id: "bfb0c68a-55fd-11ee-8c99-0242ac120002",
  },
  {
    title: "Hispanic, Latinx or Pacific Islander",
    value: "Hispanic, Latinx or Pacific Islander",
    id: "c6e0da9e-55fd-11ee-8c99-0242ac120002",
  },
  {
    title: "White: English, Welsh, Scottish, Northern Irish or British",
    value: "White: English, Welsh, Scottish, Northern Irish or British",
    id: "b30bd1c2-55fd-11ee-8c99-0242ac120002",
  },
  {
    title: "White: Gypsy or Irish Traveller, Roma or Other White",
    value: "White: Gypsy or Irish Traveller, Roma or Other White",
    id: "ba9750c4-55fd-11ee-8c99-0242ac120002",
  },
  {
    title: "White: Irish",
    value: "White: Irish",
    id: "b75b4df2-55fd-11ee-8c99-0242ac120002",
  },
  {
    title: "Other",
    value: "Other",
    id: "ca4564ca-55fd-11ee-8c99-0242ac120002",
  },
] as const;
